import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { getLSData, setLSData, setCookieValue, getCookieValue, } from "./services";


const getPluginHeaders = () => {
  const params = new URLSearchParams(window.location.search);
  // Access the data
  const pluginEmail = params.get('agentemail');
  const pluginCompanySlug = params.get('companyslug');
  let anonSession = getCookieValue('anon_session');
  if (!anonSession) {
    anonSession = uuidv4();
    setCookieValue('anon_session', anonSession, 30 * 24 * 60 * 60); // use sessionId, not anonSession
  }

  if (pluginEmail) {
    setLSData('Agent-Email', pluginEmail);
  }
  if (pluginCompanySlug) {
    setLSData('Company-Slug', pluginCompanySlug);
  }

  return { pluginEmail, pluginCompanySlug, anonSession };
}

// Create an instance of Axios
const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// request interceptor
httpClient.interceptors.request.use(
  (config) => {
    // Get plugin headers as an object
    const { pluginEmail, pluginCompanySlug, anonSession } = getPluginHeaders();
    const storedSuffix = getLSData('suffix');
    // Check if suffix exists (either from URL or from localStorage)
    if (storedSuffix) {
      // If the app is embedded (suffix exists), add suffix to the URL
      // but DON'T add Agent-Email and Company-Slug headers
      const suffixValue = storedSuffix;

      // If the URL already has parameters, append with &, otherwise use ?
      if (config.url.includes('?')) {
        config.url = `${config.url}&suffix=${suffixValue}`;
      } else {
        config.url = `${config.url}?suffix=${suffixValue}`;
      }
    } else {
      // No suffix means normal browser usage, so add the headers
      const authEmail = getLSData('Agent-Email');
      if (authEmail || pluginEmail) {
        config.headers['Agent-Email'] = authEmail || pluginEmail;
      }

      const company_slug = getLSData('Company-Slug');
      if (company_slug) {
        config.headers['Company-Slug'] = company_slug;
      }
    }

    if(anonSession) {
      config.headers['X-Session-Id'] = anonSession;
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

export default httpClient;